export const eventClosed = () => {
  window.HubSpotConversations.widget.remove();
};